import { useTranslation } from 'react-i18next';

export default ({ value, code, type }) => {
    const { t } = useTranslation();
    switch (type) {
        case 'disabled_boolean':
        case 'boolean_select':
            return value === true || value === 'true' ? t('table.yes') : t('table.no');
        default:
            return !!parseInt(value) ? 'Да' : 'Нет';
    }
};
